import React, { useRef, useState } from 'react';
import './FileUploader.css';

const ACCEPTED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/webp'];
const ACCEPTED_EXTENSIONS = '.pdf,.jpg,.jpeg,.png,.bmp,.webp';

function FileUploader({ onFileSelect }) {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const isValidFile = (file) => {
    return ACCEPTED_TYPES.includes(file.type) || file.name.toLowerCase().match(/\.(pdf|jpg|jpeg|png|bmp|webp)$/);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0 && isValidFile(files[0])) {
      onFileSelect(files[0]);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      onFileSelect(files[0]);
    }
  };

  return (
    <div
      className={`file-uploader ${isDragging ? 'dragging' : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={ACCEPTED_EXTENSIONS}
        hidden
      />
      <div className="upload-icon">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17,8 12,3 7,8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
      </div>
      <p className="upload-text">Arrastra un archivo o haz clic para seleccionar</p>
      <p className="upload-hint">PDF, JPG, PNG, BMP, WEBP</p>
    </div>
  );
}

export default FileUploader;
